
import './Icon_Arrow_Up.css';
 
function Icon_Arrow_Up() {
  return (
<div className='icon-container-arrow-up'>
<svg viewBox="0 0 24 24" className="arrow-up-svg">
<path d="m18 15-6-6-6 6"/>
</svg>
</div>
  );
}
 
export default Icon_Arrow_Up;
 
//<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-up-icon lucide-chevron-up"><path d="m18 15-6-6-6 6"/></svg>